/*
 * insured-shipping.js v6
 * - Event delegation (werkt ook na drawer open)
 * - cart-drawer.renderContents() voor live UI refresh
 * - /cart/update.js met updates voor verwijderen (change.js verwacht line key, niet variant id)
 */
(function () {
  'use strict';

  var DEFAULT_VARIANT_ID = 57379227763070;

  function getVariantId(container) {
    if (container) {
      var fromAttr = container.getAttribute('data-variant-id');
      if (fromAttr) return parseInt(fromAttr, 10);
    }
    if (window.INSURED_SHIPPING_VARIANT_ID) return parseInt(window.INSURED_SHIPPING_VARIANT_ID, 10);
    return DEFAULT_VARIANT_ID;
  }

  function callCart(endpoint, body) {
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status + ' ' + endpoint);
      return res.json();
    });
  }

  function renderCartContents(data) {
    if (!data || !data.sections) return;

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      try {
        cartDrawer.renderContents(data, true);
      } catch (e) {
        console.error('[Verzekerde Verzending] renderContents failed:', e);
      }
    }

    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      try { cartItems.onCartUpdate(); } catch (e) {}
    }
  }

  function addInsurance(variantId, container) {
    container.setAttribute('data-loading', 'true');
    return callCart('/cart/add.js', {
      items: [{ id: variantId, quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    }).then(function (data) {
      renderCartContents(data);
      callCart('/cart/update.js', {
        attributes: { 'Verzekerde Verzending': 'Ja' }
      }).catch(function () {});
      return data;
    });
  }

  function removeInsurance(variantId, container) {
    container.setAttribute('data-loading', 'true');
    // Gebruik /cart/update.js met updates dict (key = variantId, value = 0)
    // Dit verwijdert het item EN ververst sections in 1 call
    var updates = {};
    updates[variantId] = 0;

    return callCart('/cart/update.js', {
      updates: updates,
      attributes: { 'Verzekerde Verzending': 'Nee' },
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    }).then(function (data) {
      renderCartContents(data);
      return data;
    });
  }

  // Event delegation: werkt voor checkboxes die later in DOM verschijnen
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('[data-insured-shipping-checkbox]')) return;

    var container = target.closest('[data-insured-shipping]');
    if (!container) return;

    var variantId = getVariantId(container);
    var promise = target.checked
      ? addInsurance(variantId, container)
      : removeInsurance(variantId, container);

    promise
      .catch(function (err) {
        console.error('[Verzekerde Verzending] update failed:', err);
        target.checked = !target.checked;
      })
      .finally(function () {
        container.removeAttribute('data-loading');
      });
  });
})();
